import { sendTrackDataServer } from "@/features/analytics/utils/serverTrackData";

interface BaseData {
  userId: string | number | null;
  email: string | null;
}

export function trackPartnerDemoStarted(base: BaseData) {
  sendTrackDataServer({
    eventName: "VISION_PARTNER_DEMO_STARTED",
    productType: "PO",
    url: window.location.pathname,
    data: {
      user_id: base.userId,
      email: base.email,
    },
  });
}

export function trackPartnerDemoSearchInitiated(
  base: BaseData,
  filters: {
    locationLabel: string | null;
    radiusKm: number | null;
    capacityMin: number | null;
    capacityMax: number | null;
  },
) {
  sendTrackDataServer({
    eventName: "VISION_PARTNER_DEMO_SEARCH_INITIATED",
    productType: "PO",
    url: window.location.pathname,
    data: {
      user_id: base.userId,
      email: base.email,
      location_label: filters.locationLabel,
      radius_km: filters.radiusKm,
      capacity_min: filters.capacityMin,
      capacity_max: filters.capacityMax,
    },
  });
}

export function trackPartnerDemoSpaceSelected(
  base: BaseData,
  spaceId: string,
  selected: boolean,
  totalSelected: number,
) {
  sendTrackDataServer({
    eventName: "VISION_PARTNER_DEMO_SPACE_SELECTED",
    productType: "PO",
    url: window.location.pathname,
    data: {
      user_id: base.userId,
      email: base.email,
      space_id: spaceId,
      selected,
      total_selected: totalSelected,
    },
  });
}

export function trackPartnerDemoProposalViewed(
  base: BaseData,
  selectedSpaceIds: string[],
  locationLabel: string | null,
) {
  sendTrackDataServer({
    eventName: "VISION_PARTNER_DEMO_PROPOSAL_VIEWED",
    productType: "PO",
    url: window.location.pathname,
    data: {
      user_id: base.userId,
      email: base.email,
      selected_space_ids: selectedSpaceIds,
      selected_spaces_count: selectedSpaceIds.length,
      location_label: locationLabel,
    },
  });
}

export function trackPartnerDemoBackToSearch(base: BaseData) {
  sendTrackDataServer({
    eventName: "VISION_PARTNER_DEMO_BACK_TO_SEARCH",
    productType: "PO",
    url: window.location.pathname,
    data: {
      user_id: base.userId,
      email: base.email,
    },
  });
}
